<template>
  <div class="container-fluid px-md-4">
    <div class="panel-heading my-2">
      <h2 class="text-left">Tenant Management</h2>
    </div>
    <form class="needs-validation px-2 pt-2" @submit.prevent="getTenants">
      <div
        class="form-group row mx-0 justify-content-end"
        :style="{ marginBottom: '1rem' }"
      >
        <div class="my-2">
          <button
            title="Add new"
            class="k-button k-secondary"
            @click="insert"
            type="button"
          >
            <i class="fa fa-plus mr-2" aria-hidden="true"></i>

            Add new
          </button>
        </div>
      </div>
    </form>
    <div class="example-wrapper" v-if="tenants">
      <Grid
        ref="grid"
        :style="{ height: '55vh' }"
        :pageable="true"
        :sortable="true"
        :resizable="true"
        :filterable="true"
        :filter="filter"
        :groupable="false"
        :group="group"
        :sort="sort"
        :skip="skip"
        :data-items="gridData"
        :columns="columns"
        :take="take"
        @datastatechange="dataStateChange"
        @expandchange="expandChange"
      >
        <template v-slot:myTemplate="{ props }">
          <custom :data-item="props.dataItem" @edit="edit" @remove="remove" />
        </template>

        <grid-norecords> There is no data available custom </grid-norecords>
      </Grid>
      <dialog-container
        v-if="tenantInEdit"
        :dialog-title="dialogTitle"
        :data-item="tenantInEdit"
        :layouts="layouts"
        @save="save"
        @cancel="cancel"
      >
      </dialog-container>
    </div>
  </div>
</template>
<script>
import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
import { process } from "@progress/kendo-data-query";
import DialogContainer from "./DialogContainer";
import CommandCell from "./CommandCell";
import axios from "axios";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { oidcSettings } from "../../services/store";
export default {
  components: {
    Grid: Grid,
    "grid-toolbar": GridToolbar,
    "grid-norecords": GridNoRecords,
    "dialog-container": DialogContainer,
    custom: CommandCell,
    dropdownlist: DropDownList,
  },
  props: {
    identity: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return {
      base_url: undefined,
      sort: [{ field: "name", dir: "asc" }],
      tenants: undefined, //sampleroleClaims,
      selectedIdentity: this.identity,
      source: [],
      layouts: [],
      events: [],
      filter: {
        logic: "and",
        filters: [],
      },
      gridData: [],
      skip: 0,
      take: 10,
      group: [],
      tenantInEdit: undefined,
      columns: [
        {
          field: "name",
          editable: false,
          title: "Tenant Name",
        },
        { cell: "myTemplate", width: "150px", filterable: false },
      ],
    };
  },
  mounted: function () {
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";
    if (this.selectedIdentity != null) {
      this.getTenants();
      this.getLoginLayouts();
    }
  },
  watch: {
    identity: function () {
      this.selectedIdentity = this.identity;
      this.getTenants();
    },
  },
  computed: {
    dialogTitle() {
      return `${this.tenantInEdit.id === undefined ? "Add" : "Edit"} Tenant`;
    },
  },
  methods: {
    dataStateChange: function (event) {
      this.createAppState(event.data);
      console.log(event);
    },

    expandChange: function (event) {
      Vue.set(event.dataItem, event.target.$props.expandField, event.value);
    },
    createAppState: function (dataState) {
      this.group = dataState.group;
      this.take = dataState.take;
      this.skip = dataState.skip;
      this.filter = dataState.filter;
      this.sort = dataState.sort;
      console.log(dataState);
      this.getData();
    },
    getData: function () {
      console.log("aaa", this.filter);
      this.gridData = process(this.tenants, {
        take: this.take,
        skip: this.skip,
        group: this.group,
        sort: this.sort,
        filter: this.filter,
      });
    },
    toArray: function (val) {
      if (Array.isArray(val) || val == undefined) return val;
      else return val.split(",");
    },
    async getIdentityPools() {
      try {
        const response = await axios.get(
          this.base_url + "IdentityPool/GetIdentityPools"
        );
        this.source = response.data.result;
      } catch (err) {
        console.log(err);
      }
    },

    async getLoginLayouts() {
      try {
        const response = await axios.get(
          this.base_url + "Tenant/GetLoginLayouts"
        );
        this.layouts = response.data.result;
      } catch (err) {
        console.log(err);
      }
    },
    async getTenants() {
      try {
        const client_id = oidcSettings.client_id;

        const response = await axios.get(
          this.base_url + "Tenant/GetTenants/" + this.selectedIdentity.id
        );
        this.tenants = response.data.result;
        this.getData();
      } catch (err) {
        console.log(err);
      }
    },
    edit(dataItem) {
      this.tenantInEdit = this.cloneProduct(dataItem);
    },
    async remove(dataItem) {
      try {
        const client_id = oidcSettings.client_id;

        const response = await axios.delete(
          this.base_url +
            "Tenant/DeleteTenant/" +
            dataItem.id +
            "/" +
            this.selectedIdentity.id
        );
        console.log(response.data.message);
        this.tenants = this.tenants.filter((p) => p.id !== dataItem.id);
        this.getData();
      } catch (err) {
        console.log(err);
      }
    },
    async uploadLogo(dataItem) {
      const formData = new FormData();
      formData.append("file", dataItem.logo);
      return axios.post(
        this.base_url +
          "Tenant/UploadTenantLogoImage/" +
          dataItem.id +
          "/" +
          this.selectedIdentity.id,
        formData,
        {
          header: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    },
    async uploadBackgroundImage(dataItem) {
      const formData = new FormData();

      formData.append("file", dataItem.backgroundImage);
      return axios.post(
        this.base_url +
          "Tenant/UploadTenantBackgroundImage/" +
          dataItem.id +
          "/" +
          this.selectedIdentity.id,
        formData,
        {
          header: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    },
    async registerTenant(dataItem) {
      const client_id = oidcSettings.client_id;

      let data = {
        name: dataItem.name,
        ID: dataItem.id,
        RedirectUri: dataItem.redirectUri,
        // ClientID: client_id,
        // IdentityPoolID: this.selectedIdentity.id,
        // IdentityPoolName: this.selectedIdentity.name,
        LoginLayout: dataItem.loginLayout,
        IsActive: dataItem.isActive,
        AllowExternalLogin: dataItem.allowExternalLogin,
        AllowLoginWithOTP: dataItem.allowLoginWithOTP,
        DisplayName: dataItem.displayName,
        IsExternalRegAllowed: dataItem.isExternalRegAllowed,
      };
      const response = await axios
        .post(
          this.base_url + "Tenant/AddTenant/" + this.selectedIdentity.id,
          data
        )
        .then((response) => {
          var newObject = response.data.result;
          this.tenants.push(newObject);
        });
      this.dataItem = {};
      this.getData();
    },
    async addTenant(dataItem) {
      this.logoPath = null;
      if (dataItem.backgroundImage != null) {
        var result1 = await this.uploadBackgroundImage(dataItem);
      }
      if (dataItem.logo != null) {
        var result2 = await this.uploadLogo(dataItem);
        this.logoPath = result2.data.result;
      }
      var result3 = this.registerTenant(dataItem);
    },
    async editTenant(dataItem) {
      if (dataItem.backgroundImage != null) {
        var result1 = await this.uploadBackgroundImage(dataItem);
        dataItem.backgroundImage = null;
      }
      if (dataItem.logo != null) {
        var result2 = await this.uploadLogo(dataItem);
        dataItem.logo = null;
      }
      var result3 = await this.updateTenant(dataItem);
    },
    async updateTenant(dataItem) {
      let data = {
        name: dataItem.name,
        ID: dataItem.id,
        //RedirectUri:dataItem.redirectUri,
        //ClientID:client_id,
        // IdentityPoolID: this.selectedIdentity.id,
        // IdentityPoolName: this.selectedIdentity.name,
        LoginLayout: dataItem.loginLayout,
        AllowExternalLogin: dataItem.allowExternalLogin,
        AllowLoginWithOTP: dataItem.allowLoginWithOTP,
        IsActive: dataItem.isActive,
        DisplayName: dataItem.displayName,
        IsExternalRegAllowed: dataItem.isExternalRegAllowed,
      };
      try {
        const response = await axios.put(
          this.base_url + "Tenant/UpdateTenant/" + this.selectedIdentity.id,
          data
        );
        this.responseMsg = response.data.message;
        console.log(this.responseMsg);
        this.showMsg = true;
        const index = this.tenants.findIndex((p) => p.id === dataItem.id);
        this.tenants.splice(index, 1, response.data.result);
        this.dataItem = {};
        this.getTenants();
      } catch (err) {
        console.log("Ooops!" + err);
      }
    },
    save() {
      const dataItem = this.tenantInEdit;
      const tenants = this.tenants.slice();
      const isNewTenant = this.tenants.find(
        (tenant) => tenant.id == dataItem.id
      );
      if (!isNewTenant) {
        this.addTenant(dataItem);
      } else {
        this.editTenant(dataItem);
      }
      this.tenantInEdit = undefined;
    },
    cancel() {
      this.tenantInEdit = undefined;
    },
    insert() {
      this.tenantInEdit = {};
    },
    cloneProduct(product) {
      return Object.assign({}, product);
    },
  },
};
</script>
<style >
.error {
  color: brown;
  margin: auto;
  text-align: left;
  padding: 5px;
}
.needs-validation {
  background: white;
}
</style>